import BaseReducer from "./BaseReducer";

class CustmerReviewReducer extends BaseReducer {
  domain = "CustomerReview";
  type = "Modal";

  initialState = {
    open: false,
    inEditMode: false,
    reviewCompleted: false,
    venueEnterCounts: [],
    venueEnterTimes: [],
    questions: [],
    originalQuestions: [],
    questionSetId: null,
    reviewTypeId: 1,
    currentReviewId: null,
    reviewRowVersion: null, // rowVersion from Review/Read for existing reviews
    form: {},
    errors: [],
    selectedRecord: {
      id: null,
    },
    selectedReview: null,
  };
}

const reducer = new CustmerReviewReducer();

export default reducer;
